var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.Klass},[(_vm.title)?_c('h4',{staticClass:"login-alert__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.content)?_c('p',{staticClass:"login-alert__content",domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('p',{staticClass:"login-alert__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }